<template>
  <div>
    <b-card-code class="mt-2 principal">
      <b-button
        v-if="permisos.indexOf('eliminar_viajes_pendientes') !== -1"
        id="eliminar-viajes"
        variant="warning"
        size="sm"
        style="margin-right: 1%"
        @click="eliminarViajes()"
      >
        <font-awesome-icon icon="fa-solid fa-minus-circle" /> Eliminar viajes
      </b-button>
      <b-button
        id="btn-excel"
        ref="btnexcel"
        variant="primary"
        size="sm"
        style="
          margin-right: 1%;
          background: #37ef00 !important;
          border-color: #37ef00 !important;
        "
        @click="cargarDatosViajes((excel_btn = '1'))"
      >
        <font-awesome-icon icon="fa-solid fa-file-excel" />
      </b-button>
      <b-button
        id="btn-pdf"
        variant="danger"
        size="sm"
        @click="cargarDatosViajes((excel_btn = ''), (pdf_btn = '1'))"
      >
        <font-awesome-icon icon="fa-solid fa-file-pdf" />
      </b-button>
      <b-row class="mt-2">
        <b-col md="4">
          <b-form-group>
            <label>Código:</label>
            <b-form-input
              v-model="codigo"
              placeholder="Buscar por código"
              type="text"
              class="d-inline-block"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Bus:" label-for="mc-bus">
            <vue-simple-suggest
              ref="suggestComponent"
              v-model="finderfield.modelo.texto"
              pattern="\w+"
              prop="bus"
              label="Bus"
              :list="obtener_data"
              :max-suggestions="10"
              :min-length="1"
              :debounce="500"
              :filter-by-query="false"
              :prevent-submit="true"
              :controls="{
                selectionUp: [38, 33],
                selectionDown: [40, 34],
                select: [13, 36],
                hideList: [27, 35],
              }"
              :nullable-select="true"
              placeholder="Search information..."
              value-attribute="token"
              display-attribute="value"
              @select="onSuggestSelect"
              @input="onInputBusSuggest"
            >
              <div>
                <b-input-group>
                  <b-form-input
                    v-model="finderfield.modelo.texto"
                    placeholder="Bus"
                  />
                  <b-input-group-append is-text>
                    <feather-icon icon="SearchIcon" />
                  </b-input-group-append>
                </b-input-group>
                <div
                  v-if="finderfield.cargando && !finderfield.data"
                  style="
                    min-height: 857px;
                    height: fit-content;
                    width: 100%;
                    position: absolute;
                  "
                >
                  <img
                    class="loading-gif"
                    src="@/assets/images/bus/loading.gif"
                    alt="loading"
                    style="width: 45px"
                  />
                </div>
              </div>
              <template
                slot="misc-item-above"
                slot-scope="{ suggestions, query }"
              >
                <div class="misc-item">
                  <span>Buscando '{{ query }}'.</span>
                </div>
                <template v-if="suggestions.length > 0">
                  <div class="misc-item">
                    <span
                      >{{ suggestions.length }} resultado(s) encontrado(s)</span
                    >
                  </div>
                  <hr />
                </template>
                <div v-else-if="!finderfield.loading" class="misc-item">
                  <span>No hay resultados</span>
                </div>
              </template>

              <div
                slot="suggestion-item"
                slot-scope="scope"
                :title="scope.suggestion.description"
              >
                <div class="text">
                  <span v-html="boldenSuggestion(scope)" />
                </div>
              </div>

              <div
                v-if="finderfield.loading"
                slot="misc-item-below"
                slot-scope="{ suggestions }"
                class="misc-item"
              >
                <span>Cargando...</span>
              </div>
            </vue-simple-suggest>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Chofér:" label-for="mc-chofer">
            <vue-simple-suggest
              ref="suggestComponent"
              v-model="finderfieldchofer.modelo.texto"
              pattern="\w+"
              prop="chofer"
              label="Chofer"
              :list="obtener_data_chofer"
              :max-suggestions="10"
              :min-length="2"
              :debounce="500"
              :filter-by-query="false"
              :prevent-submit="true"
              :controls="{
                selectionUp: [38, 33],
                selectionDown: [40, 34],
                select: [13, 36],
                hideList: [27, 35],
              }"
              :nullable-select="true"
              placeholder="Search information..."
              value-attribute="token"
              display-attribute="value"
              @select="onSuggestSelectChofer"
              @input="onInputChoferSuggest"
            >
              <div>
                <b-input-group>
                  <b-form-input
                    v-model="finderfieldchofer.modelo.texto"
                    placeholder="Chofer"
                  />
                  <b-input-group-append is-text>
                    <feather-icon icon="SearchIcon" />
                  </b-input-group-append>
                </b-input-group>
                <div
                  v-if="finderfieldchofer.cargando && !finderfieldchofer.data"
                  style="
                    min-height: 857px;
                    height: fit-content;
                    width: 100%;
                    position: absolute;
                  "
                >
                  <img
                    class="loading-gif"
                    src="@/assets/images/bus/loading.gif"
                    alt="loading"
                    style="width: 45px"
                  />
                </div>
              </div>
              <template
                slot="misc-item-above"
                slot-scope="{ suggestions, query }"
              >
                <div class="misc-item">
                  <span>Buscando '{{ query }}'.</span>
                </div>
                <template v-if="suggestions.length > 0">
                  <div class="misc-item">
                    <span
                      >{{ suggestions.length }} resultado(s) encontrado(s)</span
                    >
                  </div>
                  <hr />
                </template>
                <div v-else-if="!finderfieldchofer.loading" class="misc-item">
                  <span>No hay resultados</span>
                </div>
              </template>

              <div
                slot="suggestion-item"
                slot-scope="scope"
                :title="scope.suggestion.description"
              >
                <div class="text">
                  <span v-html="boldenSuggestion(scope)" />
                </div>
              </div>

              <div
                v-if="finderfieldchofer.loading"
                slot="misc-item-below"
                slot-scope="{ suggestions }"
                class="misc-item"
              >
                <span>Cargando...</span>
              </div>
            </vue-simple-suggest>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group>
            <label>Trayecto:</label>
            <v-select
              id="trayecto"
              v-model="trayecto"
              :options="trayectos"
              :reduce="(option) => option.value"
              label="text"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group>
            <label>Estado:</label>
            <v-select
              id="estado"
              v-model="estado"
              :options="estados"
              :reduce="(option) => option.value"
              label="text"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group>
            <label for="fecha-hasta">Fecha creación (desde): </label>
            <flat-pickr
              v-model="fecha_desde"
              :config="configdateTimePicker"
              class="form-control"
              placeholder="Seleccionar fecha desde..."
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group>
            <label for="fecha-hasta">Fecha creación (hasta): </label>
            <flat-pickr
              v-model="fecha_hasta"
              :config="configdateTimePicker"
              class="form-control"
              placeholder="Seleccionar fecha hasta..."
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group>
            <label for="fecha-finalizacion-desde"
              >Fecha finalización (desde):
            </label>
            <flat-pickr
              v-model="fecha_finalizacion_desde"
              :config="configdateTimePicker"
              class="form-control"
              placeholder="Seleccionar fecha desde..."
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group>
            <label for="fecha-finalizacion-hasta"
              >Fecha finalización (hasta):
            </label>
            <flat-pickr
              v-model="fecha_finalizacion_hasta"
              :config="configdateTimePicker"
              class="form-control"
              placeholder="Seleccionar fecha hasta..."
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" class="pb-2">
          <b-button variant="primary" size="sm" @click="filtrar">
            <font-awesome-icon icon="fa-solid fa-magnifying-glass" /> Consultar
          </b-button>
        </b-col>
      </b-row>
    </b-card-code>

    <b-overlay :show="mostrarLoader" opacity="0.50" rounded="sm">
      <b-card-code class="principal">
        <b-col cols="12" class="pr-0 pl-0 mt-2">
          <b-table
            v-if="items.length > 0"
            bordered
            striped
            responsive
            :per-page="perPage"
            :current-page="currentPage"
            :items="items"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
          >
            <template #cell(acciones)="data">
              <b-button
                v-if="
                  permisos.indexOf('eliminar_viajes_pendientes') !== -1 &&
                  data.item.estado === 'PEN' &&
                  data.item.num_pasajeros_marcado === 0
                "
                variant="flat-danger"
                @click="
                  preguntarEliminarViaje(data.item.codigo, data.item.token)
                "
              >
                <feather-icon icon="TrashIcon" />
              </b-button>
              <b-button
                v-if="
                  permisos.indexOf('gest_bol_cadu_marcacion') !== -1 &&
                  data.item.tiene_boletos_pendientes === true
                "
                variant="flat-warning"
                @click="ingresarMarcaciones(data.item.token)"
              >
                <span v-b-tooltip.hover title="Revisar boletos caducados">
                  <feather-icon
                    icon="ClockIcon"
                    size="18"
                    class="text-warning"
                  />
                </span>
              </b-button>
            </template>
            <template #cell(codigo)="data">
              <b-link
                :to="{ name: 'marcacion', params: { token: data.item.token } }"
              >
                {{ data.value }}
              </b-link>
            </template>

            <template #cell(chofer)="data">
              <span>{{
                data.item.chofer.first_name + " " + data.item.chofer.last_name
              }}</span>
            </template>

            <template #cell(estado)="data">
              <b-badge :variant="status[1][data.value]">
                {{ status[0][data.value] }}
              </b-badge>
            </template>
            <template v-slot:cell(trayecto)="data">
              <span
                v-b-tooltip.hover
                :title="
                  data.item.trayecto.origen.nombre +
                  ' - ' +
                  data.item.trayecto.destino.nombre
                "
                >{{
                  data.item.trayecto.origen.codigo +
                  " - " +
                  data.item.trayecto.destino.codigo
                }}</span
              >
            </template>
            <template v-slot:cell(num_pasajeros_marcado)="data">
              <span>{{
                data.value + "/" + data.item.bus.cantidad_pasajeros
              }}</span>
              &nbsp;
              <span
                v-b-tooltip.hover
                title="Boletos pendientes por validar / Boletos posibles de validar"
              >
                <b-badge variant="success">
                  {{ data.item.totalpendientes }} / {{ data.item.totalvalidar }}
                </b-badge>
              </span>
              &nbsp;
              <span v-b-tooltip.hover title="Cantidad de boletos repetidos">
                <b-badge variant="warning">
                  {{ data.item.boletosrepetidos }}
                </b-badge>
              </span>
            </template>
          </b-table>

          <div v-else class="text-center">
            <p>No se encontraron registros</p>
          </div>
        </b-col>

        <b-col cols="12" class="mb-2">
          <b-pagination
            v-if="items.length > 0"
            v-model="currentPageModificado"
            :total-rows="totalRows"
            :per-page="perPage"
            first-number
            last-number
            :small="true"
            class="mb-0"
            align="center"
            prev-class="prev-item"
            next-class="next-item"
            @change="prueba"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-card-code>
    </b-overlay>
  </div>
</template>

<script>
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroupPrepend,
  BButton,
  BImg,
  BCardHeader,
  BCardGroup,
  BCardTitle,
  VBTooltip,
  BLink,
  BFormDatepicker,
  BOverlay,
} from "bootstrap-vue";
import vSelect from "vue-select";
import BCardCode from "@core/components/b-card-code";
import axios from "@/libs/axios";
import actions from "@/assets/utils/utils";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import { Spanish } from "flatpickr/dist/l10n/es.js";
import $ from "jquery";
import Vue from "vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import es from "vee-validate/dist/locale/es.json";
import VueSimpleSuggest from "vue-simple-suggest";
import "vue-simple-suggest/dist/styles.css";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";

localize({
  es,
});

localize("es");

export default {
  components: {
    BCardHeader,
    BCardGroup,
    BCardTitle,
    BCardCode,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroupPrepend,
    BButton,
    BImg,
    BLink,
    vSelect,
    BFormDatepicker,
    flatPickr,
    BOverlay,
    VueSimpleSuggest,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    "b-tooltip": VBTooltip,
  },

  data() {
    return {
      login_user: "",

      perPage: 15,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      currentPage: 1,
      currentPageModificado: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      fields: [
        {
          key: "codigo",
          label: "Código",
          thClass: "text-center",
        },
        {
          key: "trayecto",
          label: "Trayecto",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "bus.placa",
          label: "Bus",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "chofer",
          label: "Chófer",
          sortable: true,
          thClass: "text-center",
        },
        {
          key: "num_pasajeros_marcado",
          label: "# Marcados",
          sortable: true,
          tdClass: (value, key, item) => {
            if (value > item.bus.cantidad_pasajeros) {
              return "text-red";
            }
          },
          thClass: "text-center",
        },
        {
          key: "estado",
          label: "Estado",
          sortable: true,
          thClass: "text-center",
        },
        // {
        //   key: 'tiene_boletos_pendientes', label: 'Boletos pendientes', sortable: true, thClass: 'text-center',
        // },
      ],
      items: [],
      status: [
        {
          CUR: "En curso",
          FIN: "Finalizado",
          ANU: "Anulado",
          PEN: "Pendiente",
        },
        {
          FIN: "light-success",
          ANU: "light-secondary",
          CUR: "light-info",
          PEN: "light-warning",
        },
      ],

      codigo: "",
      chofer: "",
      bus: "",
      trayecto: "all",
      estado: "all",

      trayectos: [],
      estados: [],

      fecha_desde: "",

      fecha_hasta: "",

      fecha_finalizacion_desde: "",

      fecha_finalizacion_hasta: "",

      configdateTimePicker: {
        enableTime: false,
        dateFormat: "d/m/Y",
        locale: Spanish,
      },
      mostrarLoader: false,

      permisos: "",

      finderfield: {
        chosen: "",
        selected: null,
        modelo: { texto: "" },
        busqueda: { texto: "" },
        mode: "input",
        loading: false,
        cargando: false,
        data: null,
        dataCompleta: "",
      },

      finderfieldchofer: {
        chosen: "",
        selected: null,
        modelo: { texto: "" },
        busqueda: { texto: "" },
        mode: "input",
        loading: false,
        cargando: false,
        data: null,
        dataCompleta: "",
      },

      token_bus: "",
      token_chofer: "",
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
  },
  created() {
    this.comprobarPermisos();
    this.comprobarPermisoEliminar();
    $("#btn-excel").remove();
    $("#btn-pdf").remove();
    $("#btn-print").remove();
    $("#eliminar-viajes").remove();
    $("#btn-abrir-caja").remove();
    this.setToken();
  },
  mounted() {
    actions.setearTitulo("");
    this.cargarDatosViajes();
    // this.totalRows = this.items.length
    this.cargarTrayectos();
    this.cargarEstados();
    $("#contenedor-botones")
      .append($("#eliminar-viajes"))
      .append($("#btn-excel"))
      .append($("#btn-pdf"));
  },
  methods: {
    onInputBusSuggest(newValue) {
      if (
        this.finderfield &&
        this.finderfield.data &&
        !this.finderfield.data.some((e) => e.value === newValue)
      ) {
        this.token_bus = "";
      }
    },
    onInputChoferSuggest(newValue) {
      if (
        this.finderfieldchofer &&
        this.finderfieldchofer.data &&
        !this.finderfieldchofer.data.some((e) => e.value === newValue)
      ) {
        this.token_chofer = "";
      }
    },
    ingresarMarcaciones(token) {
      this.$router.push({ name: "marcacion", params: { token } });
    },
    comprobarPermisos() {
      if (
        localStorage.getItem("permisos").indexOf("viaje_viaje_consultar") === -1
      ) {
        this.$router.push({ name: "not-permitted" });
      } else {
        this.permisos = localStorage.getItem("permisos");
      }
    },
    comprobarPermisoEliminar() {
      if (
        localStorage
          .getItem("permisos")
          .indexOf("eliminar_viajes_pendientes") !== -1 ||
        localStorage.getItem("permisos").indexOf("gest_bol_cadu_marcacion") !==
          -1
      ) {
        this.fields.splice(0, 0, {
          key: "acciones",
          label: "Acciones",
          thClass: "text-center",
          thStyle: { width: "10%" },
          tdClass: "text-center",
        });
      }
    },
    filtrar() {
      this.cargarDatosViajes();
    },
    eliminarViajes() {
      this.$swal({
        title: "Eliminación de viajes pendientes",
        text: "¿Está seguro de borrar los viajes pendientes vacíos?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sí, borrar!",
        cancelButtonText: "Cancelar",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          axios
            .post("api", {
              query: `{
                        eliminarViajesPendientes{
                            status,
                            message,
                        }
                    }`,
            })
            .then((response) => {
              if (response.status === 200) {
                if (
                  response.data.data.eliminarViajesPendientes.status ===
                  "success"
                ) {
                  this.$swal({
                    icon: "success",
                    title: "Eliminar éxitoso!",
                    text: "Se ha borrado con éxito, los viajes pendientes.",
                    customClass: {
                      confirmButton: "btn btn-success",
                    },
                  });
                  this.cargarDatosViajes("", "", 0, 15, 1);
                }
              }
            });
        }
      });
    },
    cargarTrayectos() {
      axios
        .post("api", {
          query: `{
                    getTrayectos{
                        lista{
                            text,
                            value,
                        },
                        status,
                        message
                    }
                }`,
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.data.getTrayectos.status === "success") {
              this.trayectos = response.data.data.getTrayectos.lista;
              this.trayectos.push({ text: "Todos", value: "all" });
            }
          }
        });
    },
    cargarEstados() {
      axios
        .post("api", {
          query: `{
                    getEstados{
                        lista{
                            text,
                            value,
                        },
                        status,
                        message
                    }
                }`,
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.data.getEstados.status === "success") {
              this.estados = response.data.data.getEstados.lista;
              this.estados.push({ text: "Todos", value: "all" });
            }
          }
        });
    },
    prueba(value) {
      const pagina_actual = value;
      // this.currentPage = pagina_actual
      const limite_superior = value * this.perPage;
      const limite_inferior = (value - 1) * this.perPage;
      const desde = limite_inferior;
      const hasta = limite_superior;

      this.cargarDatosViajes("", "", desde, hasta, pagina_actual);
    },
    cargarDatosViajes(
      excel_btn = "",
      pdf_btn = "",
      desde = 0,
      hasta = 15,
      pagina_actual = 1
    ) {
      this.mostrarLoader = true;
      axios
        .post("api", {
          query: `query getViajes($trayecto: String!, $bus: String!, $codigo: String!, $estado: String!, $chofer: String!, $fechaDesde: String!, $fechaHasta: String!, $fechaFinalizacionDesde: String!, $fechaFinalizacionHasta: String!, $excel: String!, $pdf: String!, $desde: Int!, $hasta: Int!){
                    getViajes(trayecto:$trayecto, bus:$bus, codigo:$codigo, estado:$estado, chofer:$chofer, fechaDesde:$fechaDesde, fechaHasta:$fechaHasta, fechaFinalizacionDesde:$fechaFinalizacionDesde, fechaFinalizacionHasta:$fechaFinalizacionHasta, excel:$excel, pdf:$pdf, desde: $desde, hasta: $hasta){
                        viajes{
                            boletosrepetidos,
                            totalvalidar,
                            totalpendientes,
                            tiene_boletos_pendientes: tieneBoletosPendientes,
                            num_pasajeros_marcado: numPasajerosMarcado,
                            estado,
                            codigo,
                            token,
                            fecha_inicio: fechaInicio,
                            bus{
                                placa,
                                cantidad_pasajeros: cantidadPasajeros
                            },
                            trayecto{
                                origen{
                                    codigo,
                                    nombre
                                },
                                destino{
                                    codigo,
                                    nombre,
                                },
                                producto{
                                    nombre,
                                    codigo
                                }
                            },
                            chofer{
                                first_name: firstName,
                                last_name: lastName
                            }
                        },
                        total,
                        dataarchivo,
                        status,
                        message
                    }
                }`,
          variables: {
            trayecto: this.trayecto,
            bus: this.token_bus,
            codigo: this.codigo,
            estado: this.estado,
            chofer: this.token_chofer,
            fechaDesde: this.fecha_desde,
            fechaHasta: this.fecha_hasta,
            fechaFinalizacionDesde: this.fecha_finalizacion_desde,
            fechaFinalizacionHasta: this.fecha_finalizacion_hasta,
            excel: excel_btn,
            pdf: pdf_btn,
            desde,
            hasta,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.data.getViajes.status === "success") {
              if (response.data.data.getViajes.viajes) {
                this.items = response.data.data.getViajes.viajes;
                this.totalRows = response.data.data.getViajes.total;
                this.currentPage = 1;
                this.currentPageModificado = pagina_actual;
              } else {
                const data = response.data.data.getViajes.dataarchivo;
                if (excel_btn === "1") {
                  actions.cargarArchivos(
                    data,
                    "Viajes.xlsx",
                    "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64"
                  );
                } else {
                  actions.cargarArchivos(
                    data,
                    "Viajes.pdf",
                    "data:application/pdf;base64"
                  );
                }
              }
            }
          }
          this.mostrarLoader = false;
        });
    },
    setToken() {
      const usuarioCookie = this.$cookie.get("usuario");
      if (usuarioCookie != null) {
        const user = JSON.parse(usuarioCookie);
        this.login_user = user.username;
        axios.defaults.headers.common.Authorization = `JWT ${user.token}`; // for all requests
      }
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    newViaje() {
      this.$router.push({ name: "formviaje" });
    },

    preguntarEliminarViaje(codigo, token) {
      this.$swal({
        title: "Eliminación de viaje",
        text: `¿Está seguro que desea eliminar el viaje "${codigo}"?`,
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonText: "Eliminar",
        confirmButtonColor: "#d9534f",
      }).then((result) => {
        if (result.value) {
          this.eliminarViaje(token);
        }
      });
    },
    eliminarViaje(token) {
      this.mostrarLoader = true;
      axios
        .post("api", {
          query: `mutation eliminarViaje($tokenViaje: String!){
                   eliminarViaje(tokenViaje:$tokenViaje)
                    {
                        message,
                        status,
                    }
                }`,
          variables: {
            tokenViaje: token,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.data.eliminarViaje.status === "success") {
              this.cargarDatosViajes();
              this.showToastViajeEliminado();
            } else {
              this.$swal({
                title: "Error",
                text: response.data.data.eliminarViaje.message,
                icon: "error",
                confirmButtonColor: "#089599",
              });
            }
          }
          this.mostrarLoader = false;
        });
    },
    showToastViajeEliminado() {
      this.$toast.success(
        {
          component: ToastificationContent,
          props: {
            title: "Viaje",
            icon: "InfoIcon",
            text: "Se ha eliminado con éxito el viaje",
          },
        },
        {
          position: "bottom-right",
        }
      );
    },
    async obtener_data(inputValue) {
      this.finderfield.cargando = true;
      let results;
      await axios
        .post("api", {
          query: `query autocompletar($texto: String!){
                    autocompletar(texto:$texto){
                        lista{
                            token,
                            label,
                            value
                        },
                        status,
                        message
                    }
                }`,
          variables: {
            texto: inputValue,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.data.autocompletar.status === "success") {
              // const datos = response.data.data.autocompletar.lista
              results = response.data.data.autocompletar.lista;
              this.finderfield.data = results;
              this.finderfield.cargando = false;
            }
          }
        });
      const promise = new Promise((resolve, reject) => {
        resolve(results);
      });

      return promise;
    },
    async obtener_data_chofer(inputValue) {
      this.finderfieldchofer.cargando = true;
      let results;
      await axios
        .post("api", {
          query: `query autocompletarUsuario($texto: String!){
                    autocompletarUsuario(texto:$texto){
                        lista{
                            token,
                            label,
                            value
                        },
                        status,
                        message
                    }
                }`,
          variables: {
            texto: inputValue,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.data.autocompletarUsuario.status === "success") {
              // const datos = response.data.data.autocompletar.lista
              results = response.data.data.autocompletarUsuario.lista;
              this.finderfieldchofer.data = results;
              this.finderfieldchofer.cargando = false;
            }
          }
        });
      const promise = new Promise((resolve, reject) => {
        resolve(results);
      });

      return promise;
    },
    boldenSuggestion(scope) {
      if (!scope) return scope;
      const { suggestion, query } = scope;
      const result = this.$refs.suggestComponent.displayProperty(suggestion);
      if (!query) return result;
      const texts = query.split(/[\s-_/\\|.]/gm).filter((t) => !!t) || [""];
      return result.replace(
        new RegExp(`(.*?)(${texts.join("|")})(.*?)`, "gi"),
        "$1<b>$2</b>$3"
      );
    },
    onSuggestSelect(suggest) {
      this.finderfield.selected = suggest;
      this.token_bus = this.finderfield.selected.token;
    },
    onSuggestSelectChofer(suggest) {
      this.finderfieldchofer.selected = suggest;
      this.token_chofer = this.finderfieldchofer.selected.token;
    },
  },
};
</script>
<style>
.principal .card-header {
  display: none !important;
}
.principal .card-body {
  padding-bottom: 0 !important;
}
.text-red {
  color: red;
}
[dir] .table th,
[dir] .table td {
  padding-left: 1%;
  padding-right: 1%;
}
.vue-simple-suggest.designed .input-wrapper input {
  width: auto !important;
}
</style>
